import { render, staticRenderFns } from "./robotSwiper.vue?vue&type=template&id=0f96a78d"
import script from "./robotSwiper.vue?vue&type=script&lang=js"
export * from "./robotSwiper.vue?vue&type=script&lang=js"
import style0 from "./robotSwiper.vue?vue&type=style&index=0&id=0f96a78d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports